import AutoCompleteField from '@Fields/AutoCompleteField';
import SelectField from '@Fields/SelectField';
import TextField from '@Fields/TextField';
import LocationPickerField from '@Fields/LocationPickerField';
import { validateLocation } from '@Utilities/LocationValidator';

class ListingDetailAttachmentForm extends React.Component {

    //set the react state to the the same values as the model
    modelToState(props, setState) {
        if (setState) {
            this.setState({
                SystemOfMeasurement: props.model.SystemOfMeasurement,
                ManufacturerSelected: props.model.ManufacturerSelected,
                ManufacturersList: props.model.ManufacturersList,
                ModelSelected: props.model.ModelSelected,
                ModelList: props.model.ModelList,
                CategorySelected: props.model.CategorySelected,
                CategoriesList: props.model.CategoriesList,
                allCategoryOptions: props.model.AllCategoriesList,
                MakeOnlyCategoryOptions: props.model.AllCategoriesList,
                SerialVIN: props.model.SerialVIN,
                SerialVINSelection: props.model.SerialVINSelection,
                AllYears: props.model.Years,
                YearSelected: props.model.YearSelected != 0 ? props.model.YearSelected : props.model.Years[0],
                Years: props.model.Years,
                EquipmentIdentifier: props.model.EquipmentIdentifier,
                StockNumber: props.model.StockNumber,
                Condition: props.model.Condition,
                ConditionList: props.model.ConditionList,
                Description: props.model.Description,
                BaseCatID: props.model.BaseCatID,
                IsAttachment: props.model.IsAttachment,
                Quantity: props.model.Quantity,
                Weight: props.model.Weight,
                FleetEvalElement: [],
                ValidFECategories: props.model.ValidFECategories,
                validFECat: props.model.validFECat,
                ShowFE: props.model.ShowFE,
                VinSerialVerify: props.model.VinSerialVerify,
                bModelIsRequired: true,
                LocationViewModel: props.model.LocationViewModel,
                QueryString: props.model.QueryString,
                NextPageURL: props.model.NextPageURL,
                Translations: props.model.Translations,
                Progress: props.model.Progress,
                CurrentSite: props.model.CurrentSite,
                HighlightErrors: {},
                FormErrors: [],
                InputErrors: {},
                bEditedCatMakeModel: false
            });
        }
        else {
            return {
                SystemOfMeasurement: props.model.SystemOfMeasurement,
                ManufacturerSelected: props.model.ManufacturerSelected,
                ManufacturersList: props.model.ManufacturersList,
                ModelSelected: props.model.ModelSelected,
                ModelList: props.model.ModelList,
                CategorySelected: props.model.CategorySelected,
                CategoriesList: props.model.CategoriesList,
                allCategoryOptions: props.model.AllCategoriesList,
                MakeOnlyCategoryOptions: props.model.AllCategoriesList,
                SerialVIN: props.model.SerialVIN,
                SerialVINSelection: props.model.SerialVINSelection,
                AllYears: props.model.Years,
                YearSelected: props.model.YearSelected != 0 ? props.model.YearSelected : props.model.Years[0],
                Years: props.model.Years,
                EquipmentIdentifier: props.model.EquipmentIdentifier,
                StockNumber: props.model.StockNumber,
                Condition: props.model.Condition,
                ConditionList: props.model.ConditionList,
                Description: props.model.Description,
                BaseCatID: props.model.BaseCatID,
                IsAttachment: props.model.IsAttachment,
                Quantity: props.model.Quantity,
                Weight: props.model.Weight,
                FleetEvalElement: [],
                ValidFECategories: props.model.ValidFECategories,
                validFECat: props.model.validFECat,
                ShowFE: props.model.ShowFE,
                VinSerialVerify: props.model.VinSerialVerify,
                bModelIsRequired: true,
                LocationViewModel: props.model.LocationViewModel,
                QueryString: props.model.QueryString,
                NextPageURL: props.model.NextPageURL,
                Translations: props.model.Translations,
                Progress: props.model.Progress,
                CurrentSite: props.model.CurrentSite,
                HighlightErrors: {},
                FormErrors: [],
                InputErrors: {},
                bEditedCatMakeModel: false,
                IsRegisteredUser: props.masterViewModel.IsRegisteredUser,
                EmailVerified: props.masterViewModel.ContactViewModel ? props.masterViewModel.ContactViewModel.EmailVerified : false
            };
        }
    }

    constructor(props) {
        super(props);

        this.handleFieldChanged = this.handleFieldChanged.bind(this);
        this.handleMasterViewUpdate = this.handleMasterViewUpdate.bind(this);
        this.validatorListingDetail = this.validatorListingDetail.bind(this);
        this.modelToState = this.modelToState.bind(this);
        this.onAttachmentEntered = props.onAttachmentEntered;
        this.onCategorySelected = props.onCategorySelected;

        this.state = this.modelToState(props, false);

        // If the detail model's LocationViewModel is empty/default but ContactViewModel has location data (e.g. from cookie),
        // initialize from ContactViewModel so the location picker and XML stay in sync
        if (props.masterViewModel.ContactViewModel && props.masterViewModel.ContactViewModel.LocationViewModel) {
            var contactLoc = props.masterViewModel.ContactViewModel.LocationViewModel;
            var detailLoc = this.state.LocationViewModel;
            if (contactLoc.Country && (!detailLoc || !detailLoc.City)) {
                this.state.LocationViewModel = { ...contactLoc };
            }
        }

        //updates the parent's validator to use this method 
        var masterViewState = this.props.masterViewModel;
        masterViewState.validatorListingDetail = this.validatorListingDetail;
        masterViewState.ListingDetailViewModel.LocationViewModel = this.state.LocationViewModel;
        this.state.IsInTranslationEditorMode = masterViewState.IsInTranslationEditorMode;
        this.props.handleFormUpdate(masterViewState);
    }

    componentWillReceiveProps(Props) {
        if (Props.model.ManufacturerSelected == "") {
            this.modelToState(Props, true);
        }
        this.setState({
            IsRegisteredUser: Props.masterViewModel.IsRegisteredUser,
            EmailVerified: Props.masterViewModel.ContactViewModel ? Props.masterViewModel.ContactViewModel.EmailVerified : false
        });
    }

    handleFieldChanged(field, value) {
        var state = this.state;
        state[field] = value;

        switch (field) {
            case "ManufacturerSelected":
                state.bEditedCatMakeModel = true;
                if (state.ManufacturerSelected != null && state.ManufacturerSelected.length >= 2) {
                    var objectToSend = {
                        Manufacturer: state.ManufacturerSelected,
                        Category: state.CategorySelected,
                        BaseCategoryID: state.BaseCatID,
                        IsAttachment: true,
                    }

                    var xhr1 = new XMLHttpRequest();
                    xhr1.onload = function () {
                        state = this.state;
                        if (xhr1.status == 200) {
                            var response = JSON.parse(xhr1.response);

                            state.ManufacturerSelected = this.state.ManufacturerSelected
                            if (response.TypedText == state.ManufacturerSelected) {
                                state.ManufacturersList = response.Manufacturers;
                            }
                            else {
                                state.ManufacturersList = this.state.ManufacturersList;
                            }

                            this.handleFormUpdate(state);
                        }
                    }.bind(this);

                    xhr1.open("POST", '/listinginput/ajax/UpdateManufacturerList', true);
                    xhr1.setRequestHeader("Content-type", "application/json");
                    xhr1.send(JSON.stringify(objectToSend));
                }
                else {
                    state.ManufacturersList = [];
                    this.handleFormUpdate(state);
                }
                break;
            case "ModelSelected":
                state.bEditedCatMakeModel = true;
                if (state.ModelSelected != null && state.ModelSelected.length >= 2) {
                    var objectToSend = {
                        Model: state.ModelSelected,
                        Manufacturer: state.ManufacturerSelected,
                        Category: state.CategorySelected,
                        BaseCategoryID: state.BaseCatID,
                        IsAttachment: true,
                    }

                    var xhr2 = new XMLHttpRequest();
                    xhr2.onload = function () {
                        state = this.state;
                        if (xhr2.status == 200) {
                            var response = JSON.parse(xhr2.response);

                            state.ModelSelected = this.state.ModelSelected
                            if (response.TypedText == state.ModelSelected) {
                                state.ModelList = response.Models;
                            }
                            else {
                                state.ModelList = this.state.ModelList;
                            }

                            this.handleFormUpdate(state);
                        }
                    }.bind(this);

                    xhr2.open("POST", '/listinginput/ajax/UpdateModelList', true);
                    xhr2.setRequestHeader("Content-type", "application/json");
                    xhr2.send(JSON.stringify(objectToSend));
                }
                else {
                    state.ModelList = [];
                    this.handleFormUpdate(state);
                }
                break;
            case "CategorySelected":    //for dropdowns and radios to update object xml
                state.bEditedCatMakeModel = true;
                if (state.CategorySelected) {
                    this.onCategorySelected(state.CategorySelected);
                }
            case "YearSelected":
                this.handleMasterViewUpdate(this.state);
                break;
            case "Condition":
                this.handleMasterViewUpdate(this.state);
                break;
        }
        this.handleFormUpdate(state);
    }

    handleOnBlur(e, field = null) {
        if (field == "ManufacturerSelected" || field == "ModelSelected") {
            this.state[field] = this.state[field].toUpperCase();
        }
        else if (field == "Description") {
            this.handleMasterViewUpdate(this.state);
        }
        this.handleMasterViewUpdate(this.state);

        if (this.state.ManufacturerSelected && this.state.ModelSelected && this.state.CategorySelected && this.state.bEditedCatMakeModel) {
            this.setState({
                bEditedCatMakeModel: false
            }, function () {
                this.onAttachmentEntered();
            });
        }
    }

    //Updates ViewModels in the Master View, then the MasterView will pass it down to the other child react components
    handleMasterViewUpdate(Model) {
        var masterViewModel = this.props.masterViewModel;
        masterViewModel.ListingDetailViewModel = Model;

        // Sync LocationViewModel to the master ContactViewModel (only for non-registered users who see the location picker)
        if (Model.LocationViewModel && !(Model.IsRegisteredUser || Model.EmailVerified)) {
            if (masterViewModel.ContactViewModel) {
                masterViewModel.ContactViewModel.LocationViewModel = Model.LocationViewModel;
                // Create a new reference so React detects the change in child components (e.g., ContactSection)
                masterViewModel.ContactViewModel = { ...masterViewModel.ContactViewModel };
            }
        }

        this.props.handleFormUpdate(masterViewModel);
    }

    handleFormUpdate(Model) {
        this.setState({
            SystemOfMeasurement: Model.SystemOfMeasurement,
            ManufacturerSelected: Model.ManufacturerSelected,
            ManufacturersList: Model.ManufacturersList,
            ModelSelected: Model.ModelSelected,
            ModelList: Model.ModelList,
            CategorySelected: Model.CategorySelected,
            CategoriesList: Model.CategoriesList,
            allCategoryOptions: Model.allCategoryOptions,
            MakeOnlyCategoryOptions: Model.MakeOnlyCategoryOptions,
            SerialVIN: Model.SerialVIN,
            SerialVINSelection: Model.SerialVINSelection,
            AllYears: Model.AllYears,
            YearSelected: Model.YearSelected,
            Years: Model.Years,
            EquipmentIdentifier: Model.EquipmentIdentifier,
            StockNumber: Model.StockNumber,
            Condition: Model.Condition,
            Description: Model.Description,
            BaseCatID: Model.BaseCatID,
            Quantity: Model.Quantity,
            Weight: Model.Weight,
            FleetEvalElement: Model.FleetEvalElement,
            ValidFECategories: Model.ValidFECategories,
            validFECat: Model.validFECat,
            ShowFE: Model.ShowFE,
            VinSerialVerify: Model.VinSerialVerify,
            bModelIsRequired: Model.bModelIsRequired,
            HighlightErrors: Model.HighlightErrors,
            FormErrors: Model.FormErrors,
            InputErrors: Model.InputErrors
        });
    }

    validatorListingDetail() {
        let state = this.state;
        let bHasErrors = false;

        //category selected
        if (state.CategorySelected == "0" || state.CategorySelected == "" || state.CategorySelected == null) {
            state.HighlightErrors.CategorySelected = true;
            state.InputErrors.CategorySelected = state.Translations["IsRequired"].replace("{0}", this.state.Translations["Category"]);
            bHasErrors = true;
        }
        else {
            delete state.HighlightErrors["CategorySelected"];
            delete state.InputErrors["CategorySelected"];
        }

        var locationResult = validateLocation(state.LocationViewModel, state.Translations);
        if (locationResult.hasError) {
            state.HighlightErrors.LocationPicker = true;
            state.InputErrors.LocationPicker = locationResult.errorText;
            bHasErrors = true;
        } else {
            delete state.HighlightErrors.LocationPicker;
            delete state.InputErrors.LocationPicker;
        }

        this.handleFormUpdate(state);

        if (bHasErrors) {
            var firstErrorKey = Object.keys(state.HighlightErrors)[0];
            var firstErrorElement = firstErrorKey ? $('#' + firstErrorKey) : null;
            if (firstErrorElement && firstErrorElement.length) {
                ScrollToElement(firstErrorElement);
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }

        return bHasErrors;
    }

    UpdateXMLImmediately() {
        var objectToSend = {
            ManufacturerSelected: this.state.ManufacturerSelected,
            ModelSelected: this.state.ModelSelected,
            SerialVIN: this.state.SerialVIN,
            YearSelected: this.state.YearSelected,
            StockNumber: this.state.StockNumber,
            Condition: this.state.Condition,
            Description: this.state.Description,
            Quantity: this.state.Quantity,
            Weight: this.state.Weight,
            CategorySelected: this.state.CategorySelected,
            SystemOfMeasurement: this.state.SystemOfMeasurement,
            LocationViewModel: this.state.LocationViewModel,
        }

        var xhr = new XMLHttpRequest();
        xhr.open("POST", '/listinginput/listingdetail/savexml' + this.state.QueryString, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));
    }

    getTranslation(key) {
        return this.state.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: this.state.Translations[key] }}></span> :
            this.state.Translations[key];
    }

    render() {
        var conditionddl = new Array();
        this.state.ConditionList.forEach((condition) => conditionddl.push({ text: this.state.Translations[condition], value: condition }));

        let yearddl = [];
        for (let i = 0; i < this.state.Years.length; i++) {
            yearddl.push({ text: this.state.Years[i], value: this.state.Years[i] })
        };

        let categoryddl = [];
        for (let i = 0; i < this.state.CategoriesList.length; i++) {
            categoryddl.push({ text: this.state.CategoriesList[i], value: this.state.CategoriesList[i] })
        };

        let modelddl = [];
        for (let i = 0; i < this.state.ModelList.length; i++) {
            modelddl.push({ text: this.state.ModelList[i], value: this.state.ModelList[i] })
        };

        return (
            <form onSubmit={(e) => { e.preventDefault(); }} className="">
                <div className="validationError" style={{ textAlign: 'center' }}>
                    <span>{this.state.FormErrors}</span>
                </div>

                {/*Category*/}
                <div className="fe-section cf">
                    <div className="form-row cf">
                        <label className="label-left" htmlFor="CategoryAttachmentsSelected">{this.getTranslation("Category")} <span>*</span></label>
                        <div className="input-right">
                            <SelectField
                                id="CategoryAttachmentsSelected"
                                value={this.state.CategorySelected}
                                values={this.state.CategoriesList}
                                onFieldChanged={(e) => { this.handleFieldChanged("CategorySelected", e); }}
                                bShowFullName={true}
                                error={this.state.HighlightErrors.CategorySelected}
                                errorText={this.state.InputErrors.CategorySelected}
                                hasLabel={true}
                            />
                        </div>
                    </div>
                </div>

                {/*Manufacturer*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="ManufacturerSelected">{this.getTranslation("Manufacturer")}</label>
                    <div className="input-right">
                        <AutoCompleteField
                            id="ManufacturerSelected"
                            value={this.state.ManufacturerSelected}
                            values={this.state.ManufacturersList}
                            onFieldChanged={(e) => { this.handleFieldChanged("ManufacturerSelected", e); }}
                            onBlur={(e) => { this.handleOnBlur(e, "ManufacturerSelected"); }}
                            error={this.state.HighlightErrors.ManufacturerSelected}
                            errorText={this.state.InputErrors.ManufacturerSelected}
                            hasLabel={true}
                        />
                    </div>
                </div>

                {/*Model*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="ModelSelected">{this.getTranslation("Model")}</label>
                    <div className="input-right">
                        <AutoCompleteField
                            id="ModelSelected"
                            value={this.state.ModelSelected}
                            values={this.state.ModelList}
                            onFieldChanged={(e) => { this.handleFieldChanged("ModelSelected", e); }}
                            onBlur={(e) => { this.handleOnBlur(e, "ModelSelected"); }}
                            error={this.state.HighlightErrors.ModelSelected}
                            errorText={this.state.InputErrors.ModelSelected}
                            hasLabel={true}
                        />
                    </div>
                </div>

                {/*Year*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="YearSelected">{this.getTranslation("Year")}</label>
                    <div className="input-right">
                        <SelectField
                            id="YearSelected"
                            value={this.state.YearSelected}
                            values={yearddl}
                            onFieldChanged={(e) => { this.handleFieldChanged("YearSelected", e); }}
                            onBlur={(e) => { this.handleOnBlur("YearSelected", e); }}
                            error={this.state.HighlightErrors.YearSelected}
                            errorText={this.state.InputErrors.YearSelected}
                            hasLabel={true}
                        />
                    </div>
                </div>

                {/*Serial VIN - Think we are going to make this field site specific*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="SerialVIN">{this.getTranslation("SerialVIN")}</label>
                    <div className="input-right">
                        <TextField
                            feRequired={this.state.validFECat}
                            id="SerialVIN"
                            value={this.state.SerialVIN}
                            onFieldChanged={(e) => { this.handleFieldChanged("SerialVIN", e); }}
                            onBlur={(e) => { this.handleOnBlur(e); }}
                            error={this.state.HighlightErrors.SerialVIN}
                            errorText={this.state.InputErrors.SerialVIN}
                            hasLabel={true}
                        />
                    </div>
                </div>

                {/* Stock Number*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="StockNumber">{this.getTranslation("StockNumber")}</label>
                    <div className="input-right">
                        <TextField
                            id="StockNumber"
                            value={this.state.StockNumber}
                            onFieldChanged={(e) => { this.handleFieldChanged("StockNumber", e); }}
                            onBlur={(e) => { this.handleOnBlur(e); }}
                            error={this.state.HighlightErrors.StockNumber}
                            errorText={this.state.InputErrors.StockNumber}
                            hasLabel={true}
                        />
                    </div>
                </div>

                {/* Quantity */}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="Quantity">{this.getTranslation("Quantity")}</label>
                    <div className="input-right">
                        <TextField
                            type='number'
                            min="0"
                            id="Quantity"
                            value={this.state.Quantity}
                            NumbersOnly={true}
                            onFieldChanged={(e) => { this.handleFieldChanged("Quantity", e); }}
                            onBlur={(e) => { this.handleOnBlur(e); }}
                            error={this.state.HighlightErrors.Quantity}
                            errorText={this.state.InputErrors.Quantity}
                            hasLabel={true}
                        />
                    </div>
                </div>

                {/* Weight */}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="Weight">{this.getTranslation("Weight")}</label>
                    <div className="input-right">
                        <TextField
                            type='number'
                            min="0"
                            id="Weight"
                            value={this.state.Weight}
                            NumbersOnly={true}
                            onFieldChanged={(e) => { this.handleFieldChanged("Weight", e); }}
                            onBlur={(e) => { this.handleOnBlur(e); }}
                            error={this.state.HighlightErrors.Weight}
                            errorText={this.state.InputErrors.Weight}
                            hasLabel={true}
                        />
                    </div>
                </div>

                {/*Condition*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="conditionddl">{this.getTranslation("Condition")}: </label>
                    <div className="input-right">
                        <SelectField
                            id="conditionddl"
                            value={this.state.Condition}
                            values={conditionddl}
                            onFieldChanged={(e) => { this.handleFieldChanged("Condition", e); }}
                            error={this.state.HighlightErrors.Condition}
                            errorText={this.state.InputErrors.Condition}
                            hasLabel={true}
                        />
                    </div>
                </div>

                {/*Location - City, State, Zip*/}
                <LocationPickerField
                    getTranslation={(key) => this.getTranslation(key)}
                    locationData={this.state.LocationViewModel}
                    onLocationChanged={(loc) => {
                        var highlightErrors = this.state.HighlightErrors;
                        var inputErrors = this.state.InputErrors;
                        delete highlightErrors.LocationPicker;
                        delete inputErrors.LocationPicker;
                        this.setState({ LocationViewModel: Object.assign(this.state.LocationViewModel, loc), HighlightErrors: highlightErrors, InputErrors: inputErrors }, () => {
                            this.handleMasterViewUpdate(this.state);
                        });
                    }}
                    onValidation={(result) => {
                        var highlightErrors = this.state.HighlightErrors;
                        var inputErrors = this.state.InputErrors;
                        if (result.hasError) {
                            highlightErrors.LocationPicker = true;
                            inputErrors.LocationPicker = result.errorText;
                        } else {
                            delete highlightErrors.LocationPicker;
                            delete inputErrors.LocationPicker;
                        }
                        this.setState({ HighlightErrors: highlightErrors, InputErrors: inputErrors });
                    }}
                    onBlur={() => { this.handleMasterViewUpdate(this.state); }}
                    highlightErrors={this.state.HighlightErrors}
                    inputErrors={this.state.InputErrors}
                    showWeeklyUpdateSubscriptionCheckbox={this.props.masterViewModel.ContactViewModel.ShowWeeklyUpdateSubscriptionCheckbox}
                    onReceiveEmailsChanged={(val) => { this.props.masterViewModel.ContactViewModel.ReceiveEmails = val; this.handleMasterViewUpdate(this.state); }}
                />

                {this.props.masterViewModel.IsRearrangedDetailsPage ?
                    <PriceSection
                        masterViewModel={this.props.masterViewModel}
                        model={this.props.masterViewModel.PriceViewModel}
                        handleFormUpdate={(e) => { this.props.handleFormUpdate(e); }}
                    /> : null
                }

                {/*Description*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="Description">{this.getTranslation("Description")}</label>
                    <div className="input-right">
                        <TextField
                            id="Description"
                            type={"textarea"}
                            value={this.state.Description}
                            onFieldChanged={(e) => { this.handleFieldChanged("Description", e); }}
                            onBlur={(e) => { this.handleOnBlur(e, "Description"); }}
                            characterLimit={50000}
                            error={this.state.HighlightErrors.Description}
                            errorText={this.state.InputErrors.Description}
                            hasLabel={true}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default ListingDetailAttachmentForm;
global.ListingDetailAttachmentForm = ListingDetailAttachmentForm;